export default __webpack_public_path__ + "static/media/one.13d7f8a5.svg";